import React from "react";
import { useDispatch, connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { selectTransUnits } from "../../reducers/selectors";
import { css } from "glamor";
import { Button } from "react-bootstrap";
import Modal from "react-modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
// import '../../Styles/_modals.scss'

const DownloadFinish = (props) => {
  const [open, setOpen] = React.useState(true);

  return (
    <div>
      <Modal isOpen={props.success} className="modal-90w animate__animated animate__fadeInDownBig">
        <div className="row" style={{height: "100%"}}>
          <div className="col">
            <button className="bt-close" onClick={() => window.location.reload()}>
              <FontAwesomeIcon icon={faXmark} size="3x" />
            </button>
          </div>
          <div className="left col-5">
            <div className="translate-text pt-5 ps-5">
              <span>Success</span>
            </div>
            <p className="text pt-4 ps-5">Your download is complete</p>
            <Button className="btn-new" onClick={() => window.location.reload()}>
              Upload new file
            </Button>
          </div>
          <div className="right col-6">
            <div className="pt-5 ps-5 right-header">
              <span>
              Do you like what <br></br> you see?{" "}
            </span>
            </div>

            <p className="text-center">
              Try our free trial packed with rich features <br></br> and extended file processing limits.
            </p>
            <Button className="btn-singup" onClick={() => (window.location.href = "https://www.textunited.com/my/signup/")}>
              SIGN UP NOW
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

const mapStateToProps = createStructuredSelector({
  file: selectTransUnits,
});

export default connect(mapStateToProps)(DownloadFinish);
